import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBox from "../../../framework/components/DPTextBox"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "framework/widgets/DPAlert"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import ReactPaginate from "react-paginate"


const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const CustomerMasterTab3 = ({
  fieldManager,
  PeriodVlaue,
  PeriodOnChange,
  LimitValue,
  LimitOnChange,
  Disabled,
  DataRow,
  creditOnBlur,
  limitOnBlur,
  menuCode,
  setarRow,
  currentPageRest
}) => {


  const [alertShow, setsweetAlertShow] = useState(false)
  const [alertDesc, SetAlertDesc] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const [postsPerPage] = useState(10)

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);


  useEffect(() => {
    setCurrentPage(1)
  }, [currentPageRest])


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  //************ Custome Tax table delete row */
  function handleAddRowNested() {
    // Check if there is any existing row with empty values
    const hasEmptyRow = DataRow.find(x => x.code == "");

    if (hasEmptyRow) {
      // If there is any row with empty values, do not add a new row
      return false;
    }

    const modifiedRows = [...DataRow]
    modifiedRows.push({
      id: modifiedRows.length + 1,
      code: "",
      taxCodeDisable: false,
      desc: "",
      taxreg: "",
      state: false,
      inc: false,

    })

    const newList = modifiedRows.map((item, index) => {
      item.id = index + 1
      return item
    })

    setarRow(newList)
  }

  /**
      * @description This function is used to change the value of particular field in particular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
     * @description This function is used to change the value of complete row.
     * @param {JSON} row - row of the table.
     * @param {string} id - id of the row.
  */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  function handleRemoveRow(id) {

    const modifiedRows = [...DataRow]
    const index = modifiedRows.findIndex(obj => obj.id === id)
    modifiedRows.splice(index, 1)

    if (modifiedRows.length == 0) {
      modifiedRows.push({
        id: modifiedRows.length + 1,
        code: "",
        desc: "",
        taxCodeDisable: false,
        taxreg: "",
        state: false,
        inc: false,
      })
    }

    const newList = modifiedRows.map((item, index) => {
      item.id = index + 1
      return item
    })

    setarRow(newList)
  }
  //************ Custome Tax table delete row End*/

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <DPAlert
                  confirm_both={alertShow}
                  title={"Customer Master !"}
                  description={alertDesc}
                  showCancel={false}
                  btnColor={"success"}
                  cancelColor={"danger"}
                  onConfirm={() => {
                    setsweetAlertShow(false)
                  }}
                  btnYes={"OK"}
                />
                <Col sm={12} md={6} className="mb-4-sm">
                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_CREDITPERIOD')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Credit Period"
                      textType="text"
                      defaultValue="0.0"
                      textAlign="right"
                      value={PeriodVlaue}
                      onChange={PeriodOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_CREDITPERIOD')}
                      onBlur={creditOnBlur}
                    />
                  </div>
                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_CREDITLIMIT')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Credit Limit"
                      textType="text"
                      defaultValue="0.0"
                      textAlign="right"
                      value={LimitValue}
                      onChange={LimitOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_CREDITLIMIT')}
                      onBlur={limitOnBlur}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={12} className="mb-12-sm">
                  <table style={{ fontSize: "11px" }} id={"customerTax"} >
                    <thead className="table-light">
                      <tr>
                        <th>Tax Code </th>
                        <th></th>
                        <th>Description </th>
                        <th>Tax Reg Number</th>
                        <th style={{ textAlign: "center" }}>Status</th>
                        <th style={{ textAlign: "center" }}>Tax inclusive</th>
                      </tr>
                    </thead>
                    <tbody disabled={true}>
                      {currentPosts.map((formRow, key) => (
                        <TableRow
                          FormRow={formRow}
                          Key={key}
                          RemoveRow={handleRemoveRow}
                          Disabled={Disabled || fieldManager.disable.includes('')}
                          AlertShow={setsweetAlertShow}
                          AlertDesc={SetAlertDesc}
                          HeadColumns={HeadColumns}
                          groupFilter={groupFilter}
                          menuCode={menuCode}
                          changeRowValueChanges={changeRowValueChanges}
                          handleObjectChange={handleObjectChange}
                          DataTable={DataRow}
                        />
                      ))}
                    </tbody>
                  </table>
                  <Row sm={12} md={12} className="mb-4-sm">
                    <Col>
                      <Button
                        onClick={() => {
                          handleAddRowNested()
                        }}
                        color="success"
                        className="mt-1"
                        disabled={Disabled}
                        size="sm"
                      >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                      </Button>
                    </Col>
                    <Col>
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataRow.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default CustomerMasterTab3


const TableRow = ({ FormRow, Key, RemoveRow, Disabled,
  AlertShow, AlertDesc, HeadColumns, groupFilter, menuCode, changeRowValueChanges, handleObjectChange, DataTable }) => {

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [searchid, SetSearchID] = useState(FormRow.code != undefined ? FormRow.code : "")
  const ApiURL = window.Links.ApiURL


  useEffect(() => {

    getData(searchid)

  }, [searchid])



  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.TAX_CODE, "txtcode" + Key)) {

      // setcode(row.TAX_CODE)
      getData(row.TAX_CODE)

      var currentRow = FormRow
      currentRow.code = row.TAX_CODE
      currentRow.desc = row.TAX_DESC
      currentRow.taxCodeDisable = true
      handleObjectChange(currentRow, FormRow.id)

    } else {
      AlertShow(true)
      AlertDesc("Code already used !")
    }
    setmodal_xlarge(!modal_xlarge)
  }

  function getData(searchdata) {
    const authToken = localStorage.getItem("authToken")

    if (searchdata == "") return

    var currentRow = FormRow

    if (searchdata != "") {

      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}CustomerTax/search/${searchdata}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const newArray = responseData.data[0]
            currentRow.code = newArray.code
            currentRow.desc = newArray.name
            currentRow.taxCodeDisable = true;

            handleObjectChange(currentRow, FormRow.id)
          } else {
            currentRow.code = ""
            currentRow.desc = ""
            currentRow.taxCodeDisable = false;

            handleObjectChange(currentRow, FormRow.id)
            AlertShow(true)
            AlertDesc("Invalid Code !")
          }
        })
    }
  }


  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  async function clickSearch() {
    tog_xlarge();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id) => {

    const checkCodeAvailable = DataTable.filter(x => x.code.toLowerCase() === strCode.toLowerCase() && x.id !== FormRow.id)
    if (checkCodeAvailable.length > 0) {
      return false
    }

    return true

  }
  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "160px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              disabled={Disabled ? true : FormRow.taxCodeDisable}
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtcode" + Key}
              value={FormRow.code}
              onChange={(e) => {


                let valTax = Text(
                  e.target,
                  10,
                  false,
                  false,
                  "camel",
                  false
                )

                changeRowValueChanges(valTax, FormRow.id, "code")
              }}
              onBlur={e => {
                if (CodeValidation(e.target.value, "txtcode" + Key)) {
                  getData(e.target.value, FormRow.id, "code")
                } else {
                  AlertShow(true)
                  AlertDesc("Code already used !")
                  changeRowValueChanges("", FormRow.id, "code")
                  return
                }
                if (!e.target.value.trim()) {
                  changeRowValueChanges("", FormRow.id, "desc")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <th>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              disabled={Disabled ? true : FormRow.taxCodeDisable}
              color="success"
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm">
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </th>
      <td style={{ width: "400px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              disabled={true}
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtTaxcode" + Key}
              value={FormRow.desc}
              onChange={(e) => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              disabled={Disabled}
              labelText="Code"
              textType="text"
              textAlign="left"
              id={"txtReg" + Key}
              value={FormRow.taxreg}
              onChange={(e) => {
                var val1 = Text(e.target, 20, true, true, "any", false)
                changeRowValueChanges(val1, FormRow.id, "taxreg")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12" style={{ textAlign: "center" }}>
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              disabled={Disabled}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "state")
              }}
              checked={FormRow.state}
              id={"txtstatus" + Key}
            />
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12" style={{ textAlign: "center" }}>
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              disabled={Disabled}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "inc")
              }}
              checked={FormRow.inc}
              id={"txtinc" + Key}
            />
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              id={"btnDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
              disabled={Disabled}
            >
              <i
                className="mdi mdi-delete"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>{" "}
          {/* <DPSearchBox
            searchData={DataTables}
            columns={columns}
            defaultSorted={defaultSorted}
            mainTitle="Tax Detail Search"
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
          /> */}

          <DPSearchBoxDynamic
            searchData={[]}
            columns={HeadColumns}
            defaultSorted={defaultSorted}
            mainTitle={"Tax Detail Search"}
            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"CUSTAX"}
            MenuCode={menuCode}
            KeyVal={"TAX"}
            searchBy={"TAX_CODE"}
            FilterStr={groupFilter}
          />

        </Row>
      </td>
    </tr>
  )
}